import { createStructuredSelector } from 'reselect'

const opintelLicensesList = ({ opintelLicenses }) => opintelLicenses.getIn(['opintelLicensesList'], [])
const loading = ({ opintelLicenses }) => opintelLicenses.getIn(['loading'], false)

export default createStructuredSelector({
  loading,
  opintelLicensesList
})
